
    // merge values['link_content']  & linkData to display both: (but not updating memory or DB)
export const show_link_list = (link_content)=>{
        //console.log("values in show_link_list:" + JSON.stringify(values))
        //let link_content = thePost['PostLinks']   //pass in "values" as reference, so upon delete we can remove a link of user's coice
        let parsed_link_data =  parseNsetLinkDisplay(link_content)
        if( parsed_link_data.length < 1) return ''
        return (
            <>
             {parsed_link_data.map((item, index) => (
                <div style={{ paddingRight: '30px', marginBottom: '30px' }} key={String(index)}>
                    <a href={item.url} rel="noreferrer" target="_blank" > {item.text} </a>
                </div>
            ))}
            </>
        )
    }


const parseNsetLinkDisplay = (link_content) =>{
    if( !link_content || !link_content.trim()){
        return []
    }

    let linkData_fromDB = []
    try {
          // Attempt to parse as JSON
     linkData_fromDB = JSON.parse(link_content);
    } catch (error) {
          // If parsing fails, assume it's already a string or object
          if (isValidURL(link_content)){
            linkData_fromDB = [{id:'text_url', text:link_content, url:link_content}]
          }else{
            linkData_fromDB = [{id:'text_no_link' ,text:link_content, url:"http://notes.xstpeach.com"}]
          }
   }

   return linkData_fromDB;
}



export function formatTimestamp(timestamp) {
  const date = new Date(timestamp);
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${year}/${month}/${day} ${hours}:${minutes}`;
}

export function myIsObject(value) {
    return typeof value === 'object' 
           && value !== null 
           && !Array.isArray(value)
           && !(value instanceof Date)
           && !(value instanceof RegExp)
           && !(value instanceof Map)
         //  && !(value instanceof Set)[1][5]
}

export function myUrlDecode(myString){
    const textArea = document.createElement('textarea');
    textArea.innerHTML = myString  //.post is OSSN wall post specific JSON field name, it's content is HTML encoded (so we can use it to carry json data as a string with double quote encoded)
    const decodedString = textArea.value;
    return decodedString
}



export function myUrlEncode(myString){
    const textArea = document.createElement('textarea');
    textArea.innerText = myString;
    const ossn_post_text_encoded = textArea.innerHTML;
    return ossn_post_text_encoded
}

/*
export function displayParse2(postList) {
    const textArea = document.createElement('textarea');
    const parsedList = postList.map(
            (item)=> {


                let post_content = JSON.parse(item['post']['description'])

                textArea.innerHTML = post_content.post;  //.post is OSSN wall post specific JSON field name, it's content is HTML encoded (so we can use it to carry json data as a string with double quote encoded)
                const decodedString = textArea.value;
                let post_content_json = JSON.parse(decodedString)

                let present_list = []
                let absent_list =  []
                let note_list  = []
                let recordedAt = ''
                let recordedBy = 'not set'
                let updatedAt = ''
                let updatedBy = 'not set'
                let dateFor = new Date().toJSON().slice(0, 10)
                if( myIsObject(post_content_json) ){
                  if( post_content_json.hasOwnProperty('note_list') ){
                       note_list = post_content_json['note_list']
                   }
                   if( post_content_json.hasOwnProperty('present_list') ){
                       present_list = post_content_json['present_list']
                   }
                   if( post_content_json.hasOwnProperty('absent_list') ){
                       absent_list = post_content_json['absent_list']
                   }
                   if( post_content_json.hasOwnProperty('recordedAt') ){
                       recordedAt = post_content_json['recordedAt']
                   }
                   if( post_content_json.hasOwnProperty('recordedBy') ){
                       recordedBy = post_content_json['recordedBy']
                   }
                   if( post_content_json.hasOwnProperty('updatedAt') ){
                       updatedAt = post_content_json['updatedAt']
                   }
                   if( post_content_json.hasOwnProperty('updatedBy') ){
                       updatedBy = post_content_json['updatedBy']
                   }
                   if( post_content_json.hasOwnProperty('dateFor') ){
                       dateFor = post_content_json['dateFor']
                   }

                }


                const newItem = {
                      'dateFor':    dateFor,
                      'recordedAt':  recordedAt,
                      'recordedBy':  recordedBy,
                      'updatedAt':   updatedAt,
                      'updatedBy':   updatedBy,
                      'present_list': present_list,
                      'absent_list':  absent_list,
                      'note_list':    note_list,
                      '$id':            item['post']['poster_guid'],
                      'guid':           item['post']['guid'],
                      'PostContent':    item['post']['description'],
                      'Text':           item['text'],
                      'User':           item['user']['email'],
                      'UserId':         item['user']['guid'],
                }

               // Object.assign(item, newItem)

                return newItem;
            }
        )
    return parsedList
}
*/